export function resolveOrderGridCellFocusKey(column, fallbackKey = "client_code") {
  if (column?.type === "readonly-loading-summary") {
    return "loading_client_name";
  }

  if (column?.type === "readonly-delivery-summary") {
    return "delivery_client_name";
  }

  if (column?.type === "readonly" || column?.type === "readonly-action") {
    return fallbackKey;
  }

  return column?.key || fallbackKey;
}